var palette = {
  black: '#1b1f23',
  white: ['#fff'],
  gray: ['#fafbfc', '#f6f8fa', '#e1e4e8', '#d1d5da', '#959da5', '#6a737d', '#586069', '#444d56', '#2f363d', '#24292e'],
  blue: ['#f1f8ff', '#dbedff', '#c8e1ff', '#79b8ff', '#2188ff', '#0366d6', '#005cc5', '#044289', '#032f62', '#05264c'],
  green: ['#f0fff4', '#dcffe4', '#bef5cb', '#85e89d', '#34d058', '#28a745', '#22863a', '#176f2c', '#165c26', '#144620'],
  orange: ['#fff8f2', '#ffebda', '#ffd1ac', '#ffab70', '#fb8532', '#f66a0a', '#e36209', '#d15704', '#c24e00', '#a04100'],
  purple: ['#f5f0ff', '#e6dcfd', '#d1bcf9', '#b392f0', '#8a63d2', '#6f42c1', '#5a32a3', '#4c2889', '#3a1d6e', '#29134e'],
  red: ['#ffeef0', '#ffdce0', '#fdaeb7', '#f97583', '#ea4a5a', '#d73a49', '#cb2431', '#b31d28', '#9e1c23', '#86181d'],
  yellow: ['#fffdef', '#fffbdd', '#fff5b1', '#ffea7f', '#ffdf5d', '#ffd33d', '#f9c513', '#dbab09', '#b08800', '#735c0f'],
  blackfade15: 'rgba(27, 31, 35, 0.15)',
  blackfade20: 'rgba(27, 31, 35, 0.20)',
  blackfade35: 'rgba(27, 31, 35, 0.35)',
  blackfade50: 'rgba(27, 31, 35, 0.5)',
  whitefade15: 'rgba(255, 255, 255, 0.15)'
};
var colors = {
  palette: palette,
  text: '#24292e',
  background: palette.white[0],
  primary: palette.orange[4],
  secondary: palette.blue[5],
  cta: palette.blue[9],
  accent: palette.gray[2],
  muted: palette.gray[1],
  message: {
    border: palette.orange[5],
    background: palette.orange[1],
    text: palette.orange[9]
  }
};
var space = [0, 1, 2, 4, 8, 12, 16, 20, 24, 32, 48, 64, 96, 128, 192, 256];
var radii = ['0px', '4px', '8px', '16px', '50%'];
var lineHeights = {
  body: '1.2rem',
  heading: '2rem'
};
var fontWeights = {
  body: 400,
  heading: 700
};
var theme = {
  fonts: {
    body: 'Montserrat, sans-serif',
    heading: 'Montserrat, sans-serif'
  },
  fontSizes: [12, 14, 16, 20, 24, 32],
  colors: colors,
  palette: palette,
  space: space,
  radii: radii,
  lineHeights: lineHeights,
  fontWeights: fontWeights
};
export { theme as defaultTheme };